/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleSearchRequest
 */
export interface VehicleSearchRequest {
    /**
     * Airport IATA code or location identifier
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    pickupLocation: string;
    /**
     * Free-text pickup location (airport IATA, metro IATA, city, address, POI, or "lat,lon"). When present, takes precedence over pickup_location and routes through the unified location search (resolves + merges airport + city-desk inventory). pickup_location should still be sent (a resolved/display copy) for backward compatibility.
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    pickupQuery?: string;
    /**
     * Type of pickup location
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    pickupLocationType?: VehicleSearchRequestPickupLocationTypeEnum;
    /**
     * Supplier code for an explicitly selected rental desk (for example ZE for Hertz)
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    pickupVendorCode?: string;
    /**
     * Travelport PickupLocationNumber for an explicitly selected rental desk
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    pickupVendorLocationId?: string;
    /**
     * Pickup date and time in ISO 8601 format
     * @type {Date}
     * @memberof VehicleSearchRequest
     */
    pickupDatetime: Date;
    /**
     * Dropoff date and time in ISO 8601 format
     * @type {Date}
     * @memberof VehicleSearchRequest
     */
    dropoffDatetime: Date;
    /**
     * Optional dropoff location if different from pickup (one-way). Defaults to pickup location.
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    dropoffLocation?: string;
    /**
     * Free-text dropoff location for one-way searches (same shapes as pickup_query). When it resolves to a different location set than the pickup, the search runs one-way — which unlocks city-desk inventory at metros whose same-city round-trip quoting is broken (e.g. Manhattan).
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    dropoffQuery?: string;
    /**
     * Type of dropoff location. Defaults to pickup_location_type if not specified.
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    dropoffLocationType?: VehicleSearchRequestDropoffLocationTypeEnum;
    /**
     * Number of passengers
     * @type {number}
     * @memberof VehicleSearchRequest
     */
    passengerCount?: number;
    /**
     * Number of bags
     * @type {number}
     * @memberof VehicleSearchRequest
     */
    bagCount?: number;
    /**
     * Preferred vehicle class
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    vehicleClassPreference?: VehicleSearchRequestVehicleClassPreferenceEnum;
    /**
     * Filter results to specific vendor codes. Required when using promotional_code.
     * @type {Array<string>}
     * @memberof VehicleSearchRequest
     */
    vendorCodes?: Array<string>;
    /**
     * Vendors to search with the corporate or promotional code, independently of the public inventory vendor filter. When omitted, legacy vendor_codes targeting is used.
     * @type {Array<string>}
     * @memberof VehicleSearchRequest
     */
    codeVendorCodes?: Array<string>;
    /**
     * Corporate Discount Program (CDP) number. Also used for AAA, AARP, military, and government discount codes.
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    corporateDiscountNumber?: string;
    /**
     * Promotional or coupon code from the rental car vendor. Vendor-specific — requires vendor_codes filter.
     * @type {string}
     * @memberof VehicleSearchRequest
     */
    promotionalCode?: string;
    /**
     * When true, use test/pre-prod Travelport credentials instead of production
     * @type {boolean}
     * @memberof VehicleSearchRequest
     */
    test?: boolean;
}


/**
 * @export
 */
export const VehicleSearchRequestPickupLocationTypeEnum = {
    Airport: 'Airport',
    City: 'City'
} as const;
export type VehicleSearchRequestPickupLocationTypeEnum = typeof VehicleSearchRequestPickupLocationTypeEnum[keyof typeof VehicleSearchRequestPickupLocationTypeEnum];

/**
 * @export
 */
export const VehicleSearchRequestDropoffLocationTypeEnum = {
    Airport: 'Airport',
    City: 'City'
} as const;
export type VehicleSearchRequestDropoffLocationTypeEnum = typeof VehicleSearchRequestDropoffLocationTypeEnum[keyof typeof VehicleSearchRequestDropoffLocationTypeEnum];

/**
 * @export
 */
export const VehicleSearchRequestVehicleClassPreferenceEnum = {
    Economy: 'Economy',
    Compact: 'Compact',
    Standard: 'Standard',
    FullSize: 'FullSize',
    Premium: 'Premium',
    Luxury: 'Luxury',
    Suv: 'SUV',
    Van: 'Van',
    Any: 'Any'
} as const;
export type VehicleSearchRequestVehicleClassPreferenceEnum = typeof VehicleSearchRequestVehicleClassPreferenceEnum[keyof typeof VehicleSearchRequestVehicleClassPreferenceEnum];


/**
 * Check if a given object implements the VehicleSearchRequest interface.
 */
export function instanceOfVehicleSearchRequest(value: object): value is VehicleSearchRequest {
    if (!('pickupLocation' in value) || value['pickupLocation'] === undefined) return false;
    if (!('pickupDatetime' in value) || value['pickupDatetime'] === undefined) return false;
    if (!('dropoffDatetime' in value) || value['dropoffDatetime'] === undefined) return false;
    return true;
}

export function VehicleSearchRequestFromJSON(json: any): VehicleSearchRequest {
    return VehicleSearchRequestFromJSONTyped(json, false);
}

export function VehicleSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pickupLocation': json['pickup_location'],
        'pickupQuery': json['pickup_query'] == null ? undefined : json['pickup_query'],
        'pickupLocationType': json['pickup_location_type'] == null ? undefined : json['pickup_location_type'],
        'pickupVendorCode': json['pickup_vendor_code'] == null ? undefined : json['pickup_vendor_code'],
        'pickupVendorLocationId': json['pickup_vendor_location_id'] == null ? undefined : json['pickup_vendor_location_id'],
        'pickupDatetime': (new Date(json['pickup_datetime'])),
        'dropoffDatetime': (new Date(json['dropoff_datetime'])),
        'dropoffLocation': json['dropoff_location'] == null ? undefined : json['dropoff_location'],
        'dropoffQuery': json['dropoff_query'] == null ? undefined : json['dropoff_query'],
        'dropoffLocationType': json['dropoff_location_type'] == null ? undefined : json['dropoff_location_type'],
        'passengerCount': json['passenger_count'] == null ? undefined : json['passenger_count'],
        'bagCount': json['bag_count'] == null ? undefined : json['bag_count'],
        'vehicleClassPreference': json['vehicle_class_preference'] == null ? undefined : json['vehicle_class_preference'],
        'vendorCodes': json['vendor_codes'] == null ? undefined : json['vendor_codes'],
        'codeVendorCodes': json['code_vendor_codes'] == null ? undefined : json['code_vendor_codes'],
        'corporateDiscountNumber': json['corporate_discount_number'] == null ? undefined : json['corporate_discount_number'],
        'promotionalCode': json['promotional_code'] == null ? undefined : json['promotional_code'],
        'test': json['test'] == null ? undefined : json['test'],
    };
}

export function VehicleSearchRequestToJSON(json: any): VehicleSearchRequest {
    return VehicleSearchRequestToJSONTyped(json, false);
}

export function VehicleSearchRequestToJSONTyped(value?: VehicleSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pickup_location': value['pickupLocation'],
        'pickup_query': value['pickupQuery'],
        'pickup_location_type': value['pickupLocationType'],
        'pickup_vendor_code': value['pickupVendorCode'],
        'pickup_vendor_location_id': value['pickupVendorLocationId'],
        'pickup_datetime': value['pickupDatetime'].toISOString(),
        'dropoff_datetime': value['dropoffDatetime'].toISOString(),
        'dropoff_location': value['dropoffLocation'],
        'dropoff_query': value['dropoffQuery'],
        'dropoff_location_type': value['dropoffLocationType'],
        'passenger_count': value['passengerCount'],
        'bag_count': value['bagCount'],
        'vehicle_class_preference': value['vehicleClassPreference'],
        'vendor_codes': value['vendorCodes'],
        'code_vendor_codes': value['codeVendorCodes'],
        'corporate_discount_number': value['corporateDiscountNumber'],
        'promotional_code': value['promotionalCode'],
        'test': value['test'],
    };
}

